export default "__VITE_ASSET__DvK0eFMa__"